import axios from 'axios';
import { baseUrl } from './envhttp';
import { globalShowTimeout } from './globalTimeoutBridge';

axios.defaults.baseURL = baseUrl;

const TIMEOUT = 60000;

const handleWithTimeout = async (axiosCall) => {
    const controller = new AbortController();
    const {showTimeout, setResolvedExternally} = globalShowTimeout();

   let keepWaiting = true;

   const monitorTimeout = async () => {
    while (keepWaiting) {
        await new Promise((resolve)=>setTimeout(resolve, TIMEOUT));

        if(!keepWaiting) break;

        const choice = await showTimeout?.(controller);
        if(choice === 'cancel') {
            keepWaiting = false;
            console.warn('Request cancelled by user');
        } else if (choice === 'continue') {

        }
    }
   }

   try {
    const timeoutWatcher = monitorTimeout();

    const result = await axiosCall(controller);
    keepWaiting = false;
    setResolvedExternally?.();
    return result;
   } catch (err) {
    keepWaiting = false;
    throw err;
   }
}

export const getDataApi = (title) => {
    handleWithTimeout((controller)=>
    //console.log("saveApi: title", title)
    axios.get(title,{signal: controller.signal})
)}

export const getDataApi1 = (title) => {
    const token = localStorage.getItem("taxToken");
    return(
    handleWithTimeout((controller)=>
    //console.log("saveApi: title", title)
    axios.get(title,{signal: controller.signal,
        headers: {
          'Authorization': `Bearer ${token}`
        }
    })
))}


export const listApi = (title) => {
    return axios.get(title);
}

export const loadApi = (inputs, pUrl) => 
    handleWithTimeout((controller)=>
    axios.post(pUrl, inputs, 
       {signal: controller.signal},
    )
    )

export const loadApi1 = (inputs, pUrl) => {
    const token = localStorage.getItem("taxToken");
    return(
    // console.log("loadApi1: inputs", inputs)
    // console.log("loadApi1: pUrl", pUrl)
    handleWithTimeout((controller)=>
         axios.post(pUrl, inputs, {signal: controller.signal,
        headers: {
          'Authorization': `Bearer ${token}`
        }
    })
))}

export const saveApi = (inputs, pUrl) => {
    console.log("saveApi: inputs", inputs)
    console.log("saveApi: pUrl", pUrl)
    return axios.post(pUrl, inputs);
}

export const saveApi1 = (inputs, pUrl) => {
    const token = localStorage.getItem("taxToken");
    return(
    // console.log("saveApi1: inputs", inputs)
    // console.log("saveApi1: pUrl", pUrl)
    handleWithTimeout((controller)=>
         axios.put(pUrl, inputs, {signal: controller.signal,
        headers: {
          'Authorization': `Bearer ${token}`
        }
    })
))}

export const delApi1 = (inputs, pUrl) => {
    const token = localStorage.getItem("taxToken");
    return(
    // console.log("delApi1: inputs", inputs)
    // console.log("delApi1: pUrl", pUrl)
    handleWithTimeout((controller)=>
         axios.delete(pUrl, inputs, {signal: controller.signal,
        headers: {
          'Authorization': `Bearer ${token}`
        }
    })
))}

export const updApi = (inputs, pUrl) => {
    console.log("updApi: inputs", inputs)
    console.log("updApi: pUrl", pUrl)
    return axios.put(pUrl, inputs);
}

export const delApi = (inputs, pUrl) => {
    console.log("delApi: inputs", inputs)
    console.log("delApi: pUrl", pUrl)
    return axios.delete(pUrl, inputs);
}

export const getDataWithInputsApi = (title, processId) => {
    return axios.get(title, { params: { processId } })
}

export const getDataforTimeChartApi = (title, inputs) => {
    return axios.get(title, { params: { inputs } })
}

export const loadDataApi = (inputs, pUrl, signal) => {
    return axios.post(pUrl, inputs, {
        signal: signal,
    });
}

export const getApi = (title) => {
    console.log("saveApi: title", title)
    return axios.get(title);
}

// export const getDataApi = (title) => {
//     console.log("saveApi: title", title)
//     return axios.get(title);
// }

// export const listApi = (title) => {
//     return axios.get(title);
// }

// export const loadApi = (inputs, pUrl, signal) => {
//     return axios.post(pUrl, inputs, {
//         signal: signal,
//     });
// }

// export const saveApi = (inputs, pUrl) => {
//     console.log("saveApi: inputs", inputs)
//     console.log("saveApi: pUrl", pUrl)
//     return axios.post(pUrl, inputs);
// }

// export const getDataWithInputsApi = (title, processId) => {
//     return axios.get(title, { params: { processId } })
// }

// export const getDataforTimeChartApi = (title, inputs) => {
//     return axios.get(title, { params: { inputs } })
// }